import React from "react";
import { Box, Typography } from "@mui/material";
import having_a_coffee from "assets/having_a_coffee.svg";

export default function NotificationEmptyState() {
  return (
    <Box textAlign="center">
      <Box display="inline-block" width={"360px"} paddingY={"40px"} mt={"30px"}>
        <img src={having_a_coffee} />
        <Typography variant="subtitle1">No notifications yet</Typography>
        <Typography variant="body2" color="text.secondary">
          Enjoy a glass of tea while you wait for a new activity
        </Typography>
      </Box>
    </Box>
  );
}
